import { Http } from "Utils/Http";
import { AxiosResponse } from "axios";
import { IStorePlanResponse } from "./interfaces/Store/IStorePlanResponse";
import { IStorePlanDeleteRequest, IStorePlanRequest } from "./interfaces/Store/IStorePlanRequest";
import { ITenantAdm, ITenantAdmResponse } from "./interfaces/Tenant/ITenantAdm";
import { IUserStoreItemRequest } from "./interfaces/Store/IUserStoreItemRequest";
import { IPurchaseHistoriesRequest } from "./interfaces/Store/IPurchaseHistoriesRequest";
import { ITenantConfirmUpdatePlanRequest } from "./interfaces/Tenant/ITenantConfirmUpdatePlanRequest";
import { IUpdateTenantAdminRequest } from "./interfaces/Tenant/IUpdateTenantAdminRequest";
import { ICreateStageLibraryRequest, IUpdateStageLibraryRequest } from "./interfaces/Obra/IObraLibraries";

export class AdmApi {
  static async listPlans(): Promise<AxiosResponse<IStorePlanResponse[]>> {
    const axios = await Http.axios();
    return axios.get('/StorePlan/List');
  }

  static async getPlan(planId: number): Promise<AxiosResponse<IStorePlanResponse>> {
    const axios = await Http.axios();
    return axios.get(`/StorePlan/Get/${planId}`);
  }

  static async createOrUpdatePlan(plan: IStorePlanRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    if (plan.StorePlansId) {
      return axios.put(`/StorePlan/Update/${plan.StorePlansId}`, plan)
    }
    return axios.post('/StorePlan/Create', plan);
  }

  static async deletePlan(plan: IStorePlanDeleteRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.delete(`/StorePlan/Delete/${plan.planId}`)
  }

  static async listTenants(ignoreCache?: boolean): Promise<AxiosResponse<ITenantAdm[]>> {
    const axios = await Http.axios();
    const query = ignoreCache ? `?${Http.objectToQueryString({ ignoreCache: true })}` : '';
    return axios.get(`/Adm/ListTenants${query}`);
  }

  static async getTenantDetails(tenantId: number): Promise<AxiosResponse<ITenantAdmResponse>> {
    const axios = await Http.axios();
    return axios.get(`/Adm/GetTenantDetails/${tenantId}`);
  }

  static async updateTenant(tenant: IUserStoreItemRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.put(`/Adm/UpdateUserStoreItem/${tenant.UserStoreItemsId}`, tenant);
  }

  static async createOrUpdateTenantPayment(tenant: IPurchaseHistoriesRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    if (tenant.PurchaseHistoryId) {
      return axios.put(`/Adm/UpdatePurchase/${tenant.PurchaseHistoryId}`, tenant)
    }
    return axios.post('/Adm/AddPurchase', tenant);
  }

  static async getBillingData(userAdminId: string): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.get(`/Adm/GetBillingData/${userAdminId}`);
  }

  static async confirmUpdatePlan(tenantUpdatePlan: ITenantConfirmUpdatePlanRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.post(`/Adm/ConfirmUpdateStorePlan?userStoreItemId=${tenantUpdatePlan.userStoreItemId}&isApproved=${tenantUpdatePlan.isApproved}`);
  }

  static async listTenantUsers(id: number): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.get(`/Adm/ListTenantUsers?tenantId=${id}`);
  }

  static async updateTenantAdmin(tenantUpdateAdmin: IUpdateTenantAdminRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.patch('/Adm/UpdateTenantAdminUser', tenantUpdateAdmin);
  }

  static async listLibraries(): Promise<AxiosResponse<object[]>> {
    const axios = await Http.axios();
    return axios.get('/v2/construction-sites/stage-libraries');
  }

  static async createStageLibraries(request: ICreateStageLibraryRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.post(`/Adm/CreateStageLibraries`, request);
  }

  static async updateStageLibraries(request: IUpdateStageLibraryRequest): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.put(`/Adm/UpdateStageLibraries/${request.stageLibraryId}`, request.stageLibrary);
  }

  static async deleteStageLibraries(stageLibraryId: number): Promise<AxiosResponse<object>> {
    const axios = await Http.axios();
    return axios.delete(`/Adm/DeleteStageLibraries/${stageLibraryId}`);
  }
}
